import { render, staticRenderFns } from "./play.vue?vue&type=template&id=2d5f4bf8&scoped=true&"
import script from "./play.vue?vue&type=script&lang=ts&"
export * from "./play.vue?vue&type=script&lang=ts&"
import style0 from "./play.vue?vue&type=style&index=0&id=2d5f4bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f4bf8",
  null
  
)

export default component.exports